import { paths } from 'shell/const';

/**
 * Routes that still use the legacy app header. All other logged-in routes use
 * the global header, except those in `PATHS_WITHOUT_HEADER`.
 */
export const PATHS_WITH_APP_HEADER = [
  `/${paths.DOMESTIC_DASHBOARD}`,
  `/${paths.JAPAN_MARKETS}`,
  `/${paths.MODBUS_MAP}`,
] as const;

/**
 * Routes that should show neither the app header nor the global header.
 */
export const PATHS_WITHOUT_HEADER = [
  `/${paths.VERIFY_MANAGED_SUBSCRIPTION}`,
] as const;

export const pathMatches = (
  pathname: string,
  prefixes: readonly string[],
): boolean =>
  prefixes.some((path) => pathname === path || pathname.startsWith(`${path}/`));
